const steps = [
  {
    num: "01",
    icon: "ri-edit-2-line",
    title: "Điền thông tin",
    desc: "Cung cấp CMND/CCCD và thông tin cá nhân cơ bản. Chúng tôi sử dụng công nghệ mã hóa bảo mật để bảo vệ dữ liệu của bạn.",
  },
  {
    num: "02",
    icon: "ri-file-search-line",
    title: "Tải tài liệu hỗ trợ",
    desc: "Tải lên các tài liệu chứng minh thu nhập, ảnh chân dung. Hệ thống xác thực tự động giúp tiết kiệm thời gian.",
  },
  {
    num: "03",
    icon: "ri-shield-check-line",
    title: "Xét duyệt tự động",
    desc: "Hệ thống AI đánh giá hồ sơ trong vài phút. Chúng tôi sẽ xem xét đơn đăng ký của bạn sớm nhất có thể.",
  },
  {
    num: "04",
    icon: "ri-bank-card-line",
    title: "Nhận tiền ngay",
    desc: "Sau khi được phê duyệt, tiền sẽ được chuyển trực tiếp vào tài khoản ngân hàng được chỉ định của bạn trong tối đa 30 phút.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      className="relative py-20 md:py-28 px-6 md:px-10 bg-background-50 overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary-100 rounded-full blur-3xl opacity-60 -translate-y-1/3 translate-x-1/3"></div>

      <div className="relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <p className="text-primary-600 text-sm font-semibold tracking-widest uppercase mb-4">
              Quy trình đơn giản
            </p>
            <h2 className="font-heading text-foreground-950 text-3xl md:text-5xl leading-tight">
              Chỉ 4 bước để nhận tiền vào tài khoản
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-foreground-600 text-base md:text-lg">
              Quy trình hoàn toàn online, không cần đến văn phòng. Tổng thời gian từ
              khi đăng ký đến khi nhận tiền trong vòng tối đa 30 phút.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, idx) => (
            <div key={s.num} className="relative">
              <div className="bg-background-50 border border-background-200/70 rounded-2xl p-7 h-full hover:border-primary-300 transition-colors">
                <div className="flex items-center justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                    <i className={`${s.icon} text-primary-700 text-xl`}></i>
                  </div>
                  <span className="font-heading text-3xl text-primary-200">{s.num}</span>
                </div>
                <h3 className="font-bold text-foreground-950 text-lg mb-2">
                  {s.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{s.desc}</p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:flex absolute top-1/2 -right-3 z-10 -translate-y-1/2 w-6 h-6 rounded-full bg-accent-500 items-center justify-center">
                  <i className="ri-arrow-right-s-line text-background-50 text-base"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}